import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { RegisterFormData } from '../../types';

interface FamilyInfoProps {
  form: UseFormReturn<RegisterFormData>;
}

export function FamilyInfo({ form }: FamilyInfoProps) {
  const { register, formState: { errors } } = form;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="space-y-2">
        <Label htmlFor="fatherName">الأب *</Label>
        <Input
          id="fatherName"
          {...register('fatherName', { required: 'هذا الحقل مطلوب' })}
          placeholder="اسم الأب"
        />
        {errors.fatherName && (
          <p className="text-sm text-red-500">{errors.fatherName.message}</p>
        )}
      </div>

      <div className="space-y-2">
        <Label htmlFor="grandfather1">الجد الأول *</Label>
        <Input
          id="grandfather1"
          {...register('grandfather1', { required: 'هذا الحقل مطلوب' })}
          placeholder="اسم الجد الأول"
        />
        {errors.grandfather1 && (
          <p className="text-sm text-red-500">{errors.grandfather1.message}</p>
        )}
      </div>

      <div className="space-y-2">
        <Label htmlFor="grandfather2">الجد الثاني *</Label>
        <Input
          id="grandfather2"
          {...register('grandfather2', { required: 'هذا الحقل مطلوب' })}
          placeholder="اسم الجد الثاني"
        />
        {errors.grandfather2 && (
          <p className="text-sm text-red-500">{errors.grandfather2.message}</p>
        )}
      </div>

      <div className="space-y-2">
        <Label htmlFor="grandfather3">الجد الثالث *</Label>
        <Input
          id="grandfather3"
          {...register('grandfather3', { required: 'هذا الحقل مطلوب' })}
          placeholder="اسم الجد الثالث"
        />
        {errors.grandfather3 && (
          <p className="text-sm text-red-500">{errors.grandfather3.message}</p>
        )}
      </div>
    </div>
  );
}